import React, { Component } from 'react';
import styled from 'styled-components';
import { t } from 'src/utils/translate';

import Page from 'components/Page';
import Container from 'components/Container';
import Button from 'components/Button';

class Thankyou extends Component {
  render() {
    return (
      <Page background={require('src/assets/images/home/bg.jpg')} transparent>
        <Root>
          <ThankyouContainer>
            <Title>{t('thankyou.title')}</Title>
            <SubTitle>{t('thankyou.copy')}</SubTitle>
            <Button to="/">{t('thankyou.backBtn')}</Button>
          </ThankyouContainer>
        </Root>
      </Page>
    );
  }
}

const Root = styled.div`
  padding-top: 202px;
  padding-bottom: 100px;
`;

const ThankyouContainer = styled(Container)`
  max-width: 500px;
  text-align: center;
`;

const Title = styled.h1`
  font-family: GaramondPremrPro;
  font-size: 36px;
  color: #ffffff;
  letter-spacing: 4.5px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 58px;
`;

const SubTitle = styled.h3`
  font-family: HelveticaNeue-Light;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-bottom: 47px;
`;

export default Thankyou;



// WEBPACK FOOTER //
// ./src/pages/Thankyou/Thankyou.js